export const hasPermission = (matches, userScopes = []) => {
  if (userScopes.includes('*')) return true;
  if (!matches?.length) return false;

  return matches.every(({ route }) => {
    const scopes = route?.scopes;

    if (!Array.isArray(scopes) || scopes.length === 0) return true;

    return scopes.some((s) => userScopes.includes(s));
  });
};
